import { render, staticRenderFns } from "./HotelMealPriceList.vue?vue&type=template&id=5761ec54&"
import script from "./HotelMealPriceList.vue?vue&type=script&lang=js&"
export * from "./HotelMealPriceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports